import { forwardRef, useId, type InputHTMLAttributes, type ReactNode } from 'react';
import styles from './Checkbox.module.css';
import { cx } from '../../lib/cx';

export interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: ReactNode;
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(function Checkbox(
  { label, id, className, disabled, ...rest },
  ref,
) {
  const autoId = useId();
  const fieldId = id ?? autoId;
  return (
    <label htmlFor={fieldId} className={cx(styles.wrap, disabled && styles.disabled, className)}>
      <input
        ref={ref}
        id={fieldId}
        type="checkbox"
        className={styles.input}
        disabled={disabled}
        {...rest}
      />
      <span className={styles.box} aria-hidden>
        <svg className={styles.check} viewBox="0 0 16 16" fill="none">
          <path d="M3 8.5l3.5 3.5L13 5.5" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </span>
      {label && <span className={styles.label}>{label}</span>}
    </label>
  );
});
